import { render, staticRenderFns } from "./xflist.vue?vue&type=template&id=3c8d0d6e&scoped=true"
import script from "./xflist.vue?vue&type=script&lang=js"
export * from "./xflist.vue?vue&type=script&lang=js"
import style0 from "./xflist.vue?vue&type=style&index=0&id=3c8d0d6e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d0d6e",
  null
  
)

export default component.exports